<h2 mat-dialog-title class="dialog-title">Confirm Your Details</h2>

<mat-dialog-content>
  <!-- Display Confirmation or Form Based on the Confirmation Flag -->
  <ng-container *ngIf="!confirmation; else confirmationSection">
    <form [formGroup]="customerForm" (ngSubmit)="submit()" class="form-container">
      
      <!-- Name -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Full Name</mat-label>
        <input matInput formControlName="name" placeholder="Enter your full name" required />
        <mat-error *ngIf="customerForm.get('name')?.invalid && customerForm.get('name')?.touched">
          Name is required
        </mat-error>
      </mat-form-field>

      <!-- Phone -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Phone Number</mat-label>
        <input matInput formControlName="phone" placeholder="e.g. 0501234567" required />
        <mat-error *ngIf="customerForm.get('phone')?.invalid && customerForm.get('phone')?.touched">
          Enter a valid phone number
        </mat-error>
      </mat-form-field>

      <!-- Dates in a Row -->
      <div class="date-row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate" required />
          <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
          <mat-error *ngIf="customerForm.get('startDate')?.invalid && customerForm.get('startDate')?.touched">
            Required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="half-width">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate" required />
          <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
          <mat-error *ngIf="customerForm.get('endDate')?.invalid && customerForm.get('endDate')?.touched">
            Required
          </mat-error>
        </mat-form-field>
      </div>

    </form>
  </ng-container>

  <!-- Confirmation Section -->
  <ng-template #confirmationSection>
    <div class="confirmation-section">
      <h3>Confirm Your Booking Details</h3>

      <div class="details-card">
        <div class="customer-details">
          <h4>Your Details</h4>
          <div class="detail-item">
            <mat-icon>person</mat-icon>
            <p><strong>Name:</strong> {{ customerForm.value.name }}</p>
          </div>
          <div class="detail-item">
            <mat-icon>phone</mat-icon>
            <p><strong>Phone:</strong> {{ customerForm.value.phone }}</p>
          </div>
          <div class="detail-item">
            <mat-icon>calendar_today</mat-icon>
            <p><strong>Start Date:</strong> {{ customerForm.value.startDate | date }}</p>
          </div>
          <div class="detail-item">
            <mat-icon>calendar_today</mat-icon>
            <p><strong>End Date:</strong> {{ customerForm.value.endDate | date }}</p>
          </div>
        </div>

        <div class="equipment-details">
          <h4>Equipment Details</h4>
          <div class="detail-item">
            <mat-icon>business_center</mat-icon>
            <p><strong>Name:</strong> {{ equipmentData?.name }}</p>
          </div>
          <div class="detail-item">
            <mat-icon>local_offer</mat-icon>
            <p><strong>Brand:</strong> {{ equipmentData?.brand }}</p>
          </div>
          <div class="detail-item">
            <mat-icon>build</mat-icon>
            <p><strong>Model:</strong> {{ equipmentData?.model }}</p>
          </div>
          <div class="detail-item">
  <mat-icon>attach_money</mat-icon>
  <p>
    <strong>Price:</strong>
    AED
    {{
      data?.selectedPriceType === 'daily'
        ? equipmentData?.dailyRate
        : equipmentData?.monthlyRate
    }}
    /
    {{
      data?.selectedPriceType === 'daily' ? 'day' : 'month'
    }}
  </p>
</div>
        </div>

        <div class="action-buttons">
          <button mat-raised-button color="primary" (click)="confirmDetails()">Confirm</button>
          <button mat-stroked-button color="warn" (click)="editDetails()">Edit Details</button>
        </div>
      </div>
    </div>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="warn" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="customerForm.invalid || confirmation">
    Proceed
  </button>
</mat-dialog-actions>
